import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';

import('react-grab').then(({ registerPlugin }) => {
  // Officially supported: hide the entire React Grab toolbar via a theme override.
  registerPlugin({
    name: 'hide-toolbar',
    theme: { toolbar: { enabled: false } },
  });
});

ReactDOM.render(<App />, document.getElementById('root'));
